<template>
  <header class="gridx">
    <vs-navbar
      v-model="indexActive"
      :color="topbarColor"
      class="topnavbar"
      text-color="rgba(255,255,255,0.7)"
      active-text-color="rgba(255,255,255,1)"
    >
      <!---
      Template logo
      -->
      <div slot="title" class="themelogo">
        <img :src="logo" v-if="logo" alt="Dashboard" />
        <span class="logo-text" v-if="title">{{ title }}</span>
      </div>
      <!---
      Mobile toggle
      -->
      <div slot="title">
        <div class="hiddenDesktop cursor-pointer" @click.stop="activeSidebar">
          <vs-icon icon="menu"></vs-icon>
        </div>
      </div>
      <!---
      Desktop Toggle
      -->
      <div class="hiddenMobile cursor-pointer" @click="toggleSidebar">
        <vs-icon icon="menu"></vs-icon>
      </div>

      <vs-spacer></vs-spacer>
      <!---
      Search new dd
      -->
      <vs-dropdown vs-trigger-click left class="cursor-pointer pr-2 pl-2 ml-1 mr-1">
        <a class="text-white-dark" href="#" href.prevent>
          <vs-icon icon="search"></vs-icon>
        </a>
        <vs-dropdown-menu class="topbar-dd">
          <div class="p-2 m-1">
            <vs-input class placeholder="Search & hit enter" v-model="searchvalue" />
          </div>
        </vs-dropdown-menu>
      </vs-dropdown>

      <!---
      Craete new dd
      -->
      <vs-dropdown vs-trigger-click left class="cursor-pointer pr-2 pl-2 ml-1 mr-md-3">
        <a :title="user.name" class="text-white-dark user-image" href="#">
          <img :src="user.avatar" />
        </a>
        <vs-dropdown-menu class="user-dd common-dd topbar-dd">
          <div>
            <div class="d-flex align-items-center p-3 bg-danger text-white mb-2">
              <div class>
                <img
                  :src="user.avatar"
                  :alt="user.name"
                  class="rounded-circle"
                  width="60"
                />
              </div>
              <div class="ml-2">
                <h4 class="mb-0 text-white">{{user.name}}</h4>
                <p class="mb-0">{{user.email}}</p>
              </div>
            </div>

            <vs-dropdown-item>
              <vs-icon icon="person_outline" class="mr-1"></vs-icon>
              <router-link to="/users/profile">Profile</router-link>
            </vs-dropdown-item>

            <hr class="mb-3" />

            <vs-button
              color="danger"
              type="filled"
              size="small"
              class="rounded-button ml-3 mb-3"
              @click="logout"
            >Logout</vs-button>
          </div>
        </vs-dropdown-menu>
      </vs-dropdown>
    </vs-navbar>
  </header>
</template>

<script>
import {AuthService} from "../../../services/auth.service";

export default {
  name: "Navbar",
  props: {
    topbarColor: {
      type: String,
      default: "#2962ff"
    },
    title: {
      type: String
    },
    logo: {
      type: String
    },
  },
  data: () => ({
    indexActive: 0,
    searchvalue: ""
  }),

  methods: {
    //This is for sidebar trigger in mobile
    activeSidebar() {
      this.$store.commit("TOGGLE_SIDEBAR_ACTIVE", true);
    },
    //This is for sidebar trigger in Desktop
    toggleSidebar() {
      if (!this.showToggle) {
        this.$store.commit("TOGGLE_REDUCE_SIDEBAR", true);
        this.$store.dispatch("updateSidebarWidth", "mini");
      } else {
        this.$store.commit("TOGGLE_REDUCE_SIDEBAR", false);
        this.$store.dispatch("updateSidebarWidth", "default");
      }
    },
    logout() {
      AuthService.makeLogout();
    }
  },
  computed: {
    // Data For User Dropdown
    user:  {
      get() {
        return {
          avatar: this.$store.state.user.currentUser.avatar,
          name: this.$store.state.user.currentUser.name,
          email: this.$store.state.user.currentUser.username
        };
      },
    },

    showToggle: {
      get() {
        return this.$store.state.layout.isSidebarReduced;
      }
    }
  }
};
</script>
